/**
 * Responsive youtube iframes
 *
 */
const init = function() {
  const iframes = document.querySelectorAll('iframe[src*="youtube"]');
  if (iframes.length > 0) {
    iframes.forEach(element => {
      const wrapper = document.createElement('div');
      wrapper.classList.add('iframe-container');
      element.parentNode.insertBefore(wrapper, element);
      wrapper.appendChild(element);
    });
  }
}


export default {
  init,
}
